import { useEffect, useMemo, useState } from "react";
import { getObjections } from "@/lib/apiClient";
import { Search, Copy, Check, MessageSquareQuote } from "lucide-react";
import { toast } from "sonner";

function ObjectionCard({ item }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    navigator.clipboard.writeText(item.answer);
    setCopied(true);
    toast.success("Antwoord gekopieerd");
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div data-testid={`objection-${item.id}`} className="rounded-2xl border border-[#E2E7EC] bg-white p-6 transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex items-start gap-3 mb-3">
        <div className="h-9 w-9 rounded-xl bg-[#D6F3F3] flex items-center justify-center shrink-0">
          <MessageSquareQuote className="h-4 w-4 text-[#16BFBF]" strokeWidth={1.75} />
        </div>
        <p className="font-heading font-semibold text-lg text-[#16202B] leading-snug">{item.question}</p>
      </div>
      <p className="text-[15px] leading-relaxed text-[#5B6675] pl-12">{item.answer}</p>
      <div className="pl-12 mt-4">
        <button
          data-testid={`copy-${item.id}`}
          onClick={copy}
          className="inline-flex items-center gap-2 text-sm font-medium text-[#001C51] hover:text-[#0A337A] transition-colors"
        >
          {copied ? <Check className="h-4 w-4 text-[#0C6E6E]" /> : <Copy className="h-4 w-4" />}
          {copied ? "Gekopieerd" : "Kopieer antwoord"}
        </button>
      </div>
    </div>
  );
}

export default function Objections() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    getObjections().then(setItems).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    if (!term) return items;
    return items.filter(
      (i) =>
        i.question.toLowerCase().includes(term) ||
        i.answer.toLowerCase().includes(term) ||
        (i.tags || []).some((t) => t.toLowerCase().includes(term))
    );
  }, [items, q]);

  return (
    <div className="px-6 lg:px-12 py-10 max-w-5xl mx-auto fe-fade-up">
      <header className="mb-8">
        <h1 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight text-[#16202B]">Antwoorden op bezwaren</h1>
        <p className="text-[#5B6675] mt-2">Zoek snel het juiste antwoord terwijl je aan de telefoon zit.</p>
      </header>

      <div className="relative mb-8">
        <Search className="h-5 w-5 text-[#5B6675] absolute left-4 top-1/2 -translate-y-1/2" strokeWidth={1.75} />
        <input
          data-testid="objection-search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Zoek op vraag of trefwoord (bijv. 'kosten', 'makelaar')…"
          className="w-full rounded-xl border border-[#E2E7EC] bg-white pl-12 pr-4 py-4 text-[15px] outline-none focus:ring-2 focus:ring-[#001C51] focus:ring-offset-1"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {filtered.map((item) => (
          <ObjectionCard key={item.id} item={item} />
        ))}
      </div>
      {filtered.length === 0 && (
        <p className="text-center text-[#5B6675] py-16" data-testid="objection-empty">Geen antwoord gevonden voor "{q}".</p>
      )}
    </div>
  );
}
